export async function generateSessionMLink() {
	const tempLink = document.createElement("a");
	tempLink.style.display = "none";
	tempLink.setAttribute("href", process.env.REACT_APP_SESSIONM_URL ?? "");
	tempLink.setAttribute("target", "_blank");
	tempLink.setAttribute("rel", "noopener noreferrer");

	document.body.appendChild(tempLink);
	tempLink.click();

	setTimeout(function () {
		document.body.removeChild(tempLink);
	}, 200);
}
